import {
  getItem as getLocalItem,
  getLocalStorageWithExpiry,
  setItem as setLocalItem,
  setLocalStorageWithExpiry,
} from '@/core/services/storage/utils/localStorageUtil';
import type {
  GetDataOptions,
  SaveDataOptions,
} from '../../domain/interfaces/StorageRepository';

import { deserialize, serialize } from './storageSerialization';

export class LocalStorageRepository {
  saveData<T>(key: string, value: T, options: SaveDataOptions): void {
    const expiryDays = options.expiryDays;
    const serialized = serialize(value);

    // For expiring values we store a wrapper { value, expiry } and use the repo-level serializer.
    if (expiryDays != null) {
      setLocalStorageWithExpiry(key, serialized, expiryDays);
      return;
    }

    // Non-expiring values can use localStorage's JSON parsing directly.
    setLocalItem(key, value);
  }

  getData<T>(key: string, _options?: GetDataOptions): T | null {
    const rawWithExpiry = getLocalStorageWithExpiry(key);
    if (rawWithExpiry == null) {
      // Fallback to non-expiring localStorage values.
      return getLocalItem<T>(key);
    }

    if (typeof rawWithExpiry === 'string') {
      return deserialize<T>(rawWithExpiry);
    }

    return rawWithExpiry as unknown as T;
  }
}

